import styled from 'styled-components/macro'
import { DefaultParagraphLargeFactory, DefaultTitleMediumFactory } from '../core/Typograph/Typograph.Style'

export const Container = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    justifyContent: "space-between",
    width: "100%",

    [theme.breakpoint.lg()]: {
        flexDirection: 'row',
        gap: 64,
    }
}))

export const Content = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    maxWidth: '544px'
}))

export const Title = styled.h3(({ theme }) => ({
    ...DefaultTitleMediumFactory({ theme }),
    color: theme.color.neutral['08']
}))

export const Paragraph = styled.h3(({ theme }) => ({
    ...DefaultParagraphLargeFactory({ theme }),
    color: theme.color.neutral['08']
}))

export const Item = styled.div(({ theme, no }) => ({
    color: no ? theme.color.brandPrimary.light : theme.color.neutral['08'],
    width: '100%'
}))

export const ItemDescription = styled.p(({ theme }) => ({
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',

    [theme.breakpoint.lg()]: {
        fontSize: '16px',
        lineHeight: '24px',
    }
}))

export const ItemLink = styled.a(({ theme }) => ({
    textDecoration: 'underline',
    fontWeight: 500,
    fontSize: '18px',
    
    [theme.breakpoint.lg()]: {
        fontSize: '20px'
    }
}))

export const ItemLinkCustom = styled.a(({ theme }) => ({
    textDecoration: 'underline',
    fontWeight: 500,
    fontSize: '28px',
    
    [theme.breakpoint.lg()]: {
        fontSize: '32px'
    }
}))

export const ItemHeader = styled.div(() => ({
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px'
}))

export const PhoneNumber = styled.div(({ theme, isAssistance }) => ({
    display: `${isAssistance ? "flex" : "block"}`,
    gap: 24,
    flexDirection: 'column',

    [theme.breakpoint.lg()]: {
        flexDirection: 'row',
        gap: 16
    }
}))

export const VerticalDivider = styled.div(({ theme }) => ({
    width: '100%',
    height: 1,
    background: theme.color.neutral["08"],

    [theme.breakpoint.lg()]: {
        width: 1,
        height: 'auto',
    }
}))

export const HorizontalDivider = styled.div(({ theme }) => ({
    border: `1px solid ${theme.color.neutral["08"]}`,
    width: '100%',
    height: '0px',
    margin: "32px 0"
}))